import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: {},
  profileData: {}, // New state field for showProfile data
};

export const AdminSlice = createSlice({
  name: "Admin",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    showProfile: (state, action) => {
      state.profileData = action.payload;
    },
  },
});

export const { setUserInfo, showProfile } = AdminSlice.actions;

export default AdminSlice.reducer;
